// ===========================================================================
//  LES GUIDES — le contenu de recherche du site.
//
//  Chaque fichier vise UNE requête Google et une seule (« how to block porn
//  on iphone », « covenant eyes alternative »…). Le titre contient la
//  requête, la description est l'extrait que Google affiche, le corps
//  répond honnêtement — y compris sur ce que d'autres méthodes font bien —
//  puis renvoie vers /register.
//
//  L'ordre ici est celui du sommaire (/guides) : les pages « comment
//  bloquer sur <appareil> » d'abord, ce sont celles qu'un visiteur décidé
//  cherche ; le fond (pourquoi la volonté perd) ensuite ; les comparatifs
//  en dernier.
//
//  Règles d'écriture, identiques à la landing (voir MARKETING-PROMPT.md) :
//  deuxième personne, phrases courtes, un mécanisme décrit et jamais un
//  sermon. AUCUN chiffre inventé, aucune promesse de santé, rien de
//  faux sur un concurrent — ce qu'on dit d'eux se vérifie sur leur site.
//
//  Ajouter un guide : un fichier ici, une ligne dans ce tableau. Le
//  prérendu (scripts/prerender.js) le découvre par le sommaire et
//  l'ajoute au sitemap tout seul.
// ===========================================================================
import iphone from './how-to-block-porn-on-iphone'
import mac from './how-to-block-porn-on-mac'
import windows from './how-to-block-porn-on-windows'
import uninstall from './porn-blocker-you-cant-uninstall'
import quit from './how-to-quit-porn'
import incognito from './does-incognito-bypass-porn-blockers'
import screenTime from './is-screen-time-enough-to-block-porn'
import noPartner from './porn-blocker-without-accountability-partner'
import covenantEyes from './covenant-eyes-alternative'
import blockerx from './blockerx-alternative'
import ipad from './how-to-block-porn-on-ipad'
import safari from './how-to-block-porn-on-safari'
import chrome from './how-to-block-porn-on-chrome'
import router from './how-to-block-porn-on-wifi-router'
import reddit from './block-nsfw-on-reddit-permanently'
import xTwitter from './block-porn-on-x-twitter'
import safeSearch from './lock-safesearch-and-block-google-images'
import dns from './dns-porn-blocker'
import vpn from './porn-blocker-that-blocks-vpn'
import lockScreenTime from './lock-screen-time-so-it-cant-be-bypassed'
import supervised from './supervised-iphone-explained'
import forAdults from './porn-blocker-for-adults'
import delay from './porn-blocker-with-a-delay'
import coldTurkey from './cold-turkey-for-iphone'
import hardstop from './hardstop-alternative'

// Ordre = ordre d'affichage dans chaque rubrique du sommaire.
const GUIDES = [
  // Appareils et plateformes
  iphone, ipad, mac, windows, safari, chrome, router, reddit, xTwitter, safeSearch,
  // Le mécanisme : pourquoi ça se contourne, ce qui tient
  uninstall, supervised, dns, vpn, incognito, screenTime, lockScreenTime, delay, forAdults, noPartner,
  // Arrêter
  quit,
  // Comparatifs
  covenantEyes, blockerx, hardstop, coldTurkey
]

// Les rubriques du sommaire (/guides). Chaque guide porte un `category` ;
// un guide sans rubrique connue tombe dans la dernière. Le sommaire devient
// ainsi une page « pilier » : un titre par rubrique, et les articles de la
// rubrique en dessous — c'est la structure en grappes que Google lit le
// mieux sur un site de cette taille.
export const CATEGORIES = [
  { id: 'device', title: 'Block porn on each device', lead: 'Step by step, from the free setting already on the device to the lock that stays.' },
  { id: 'holds', title: 'Why blockers get bypassed — and what holds', lead: 'Passcodes, incognito, VPNs, profiles: where each layer gives way at two in the morning.' },
  { id: 'quit', title: 'Quitting', lead: 'The mechanics of relapse, and a method that removes the nightly fight instead of asking you to win it.' },
  { id: 'compare', title: 'Compared with other blockers', lead: 'Accountability, app-level filters, DNS: what each model is built on, and what that means for you.' }
]

// ---------------------------------------------------------------------------
//  « À lire ensuite » : calculé ici, pas seulement écrit à la main.
//
//  Constat Search Console du 11 sept. 2026 : sur 25 guides, deux recevaient
//  19 et 20 liens entrants (iphone, uninstall) et onze n'en recevaient
//  aucun ou un seul — et ce sont, à peu près, ceux que Google a « explorés
//  sans indexer ». Le `next` de chaque guide est une liste éditoriale qui
//  renvoie presque toujours vers les deux mêmes pages ; il reste en tête,
//  mais on le complète pour que CHAQUE guide reçoive des liens :
//    1. les choix de l'auteur (`next`) ;
//    2. les deux guides qui suivent dans sa rubrique (anneau : le dernier
//       renvoie au premier) — chaque guide reçoit donc deux liens de sa
//       rubrique, quoi qu'il arrive ;
//    3. un dernier, pris parmi ceux qui ont le moins de liens entrants à ce
//       stade, pour lisser le reste.
//  Six cartes, calculées une fois au chargement, dans l'ordre du sommaire :
//  le prérendu produit donc le même HTML à chaque build.
// ---------------------------------------------------------------------------
const RELATED_COUNT = 6

function buildRelated () {
  const bySlug = Object.fromEntries(GUIDES.map(g => [g.slug, g]))
  const inbound = Object.fromEntries(GUIDES.map(g => [g.slug, 0]))
  const related = {}

  GUIDES.forEach(g => {
    const picks = []
    const add = s => { if (s && s !== g.slug && bySlug[s] && !picks.includes(s)) picks.push(s) }

    ;(g.next || []).forEach(add)

    const ring = GUIDES.filter(x => x.category === g.category)
    const i = ring.findIndex(x => x.slug === g.slug)
    if (ring.length > 1) {
      add(ring[(i + 1) % ring.length].slug)
      add(ring[(i + 2) % ring.length].slug)
    }

    related[g.slug] = picks.slice(0, RELATED_COUNT)
    related[g.slug].forEach(s => { inbound[s]++ })
  })

  // Troisième passe : compléter avec les guides les moins liés.
  GUIDES.forEach(g => {
    while (related[g.slug].length < RELATED_COUNT) {
      const poorest = GUIDES
        .filter(x => x.slug !== g.slug && !related[g.slug].includes(x.slug))
        .sort((a, b) => inbound[a.slug] - inbound[b.slug])[0]
      if (!poorest) break
      related[g.slug].push(poorest.slug)
      inbound[poorest.slug]++
    }
  })

  return related
}

const RELATED = buildRelated()

// Les guides à proposer sous un article, dans l'ordre : choix de l'auteur,
// voisins de rubrique, puis les moins liés.
export function relatedGuides (guide) {
  return (RELATED[guide.slug] || []).map(s => GUIDES.find(g => g.slug === s)).filter(Boolean)
}

export default GUIDES
